import { getMcUserInfo } from '@app/apis/mcUserInfoApi';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useJbTokens } from './useJbTokens';
import { useSessionStorage } from './useSessionStorage';

export function useMcUserInfo() {
  const { tokens, isPending: tokensPending, error: tokensError } = useJbTokens();

  const fuel2token = tokens?.fuel2token;

  const {
    isPending,
    error,
    data: userInfo,
  } = useQuery({
    queryKey: ['mcUserInfo', tokens],
    enabled: !!fuel2token,
    queryFn: () => getMcUserInfo(tokens),
  });

  const { setValue: setBuId } = useSessionStorage('buId', '');

  useEffect(() => {
    if (userInfo) {
      setBuId(userInfo);
    }
  }, [setBuId, userInfo]);

  if (tokensPending) {
    return { isPending: true, error: null, userInfo: null };
  }

  if (tokensError) {
    return { isPending: false, error: tokensError, userInfo: null };
  }

  return { isPending, error, userInfo };
}
